<template>
    <div id="mailbox" v-if="IsEmailEnabled()">
        <div class="route-page-content">
            <SidebarChild :selectedItem="selectedTab" :items="menuItems" :focusActive="true"
                @selected="handleSidebarSelection" />
            <div class="page-content-wrapper">
                <EmailTemplates v-if="isSelected('templates')" />
                <EmailBroadcastList v-if="isSelected('broadcast')" />
                <EmailCustomerGroups v-if="isSelected('customer-groups')" />
                <NewMailInterface v-if="isSelected('inbox')" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import * as _ from "lodash";
import { newMailSound } from "../../../utils/notificationSounds";
import CONFIG from "../../../config/config";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import EmailTemplates from "./templates/EmailTemplates.vue";
import EmailBroadcastList from "./broadcast/EmailBroadcastList.vue";
import EmailCustomerGroups from "./customer-groups/CustomerGroups.vue";
import NewMailInterface from "./new/NewMailInterface.vue";

const MAIL_NEW_FEATURES_ENABLED = [
    "local.supsis.live",
    "beta.supsis.live",
    "supsis.live",
    "ataksms.supsis.live",
    "ertugrul.supsis.live",
    "turcaf.supsis.live",
    "kobiturkiye.supsis.live",
    "atilimfuar.supsis.live",
    "ankaron.supsis.live"
].includes(window.location.hostname);
const log = log2("Mail");
export default {
    name: "Mail",
    components: {
        EmailCustomerGroups,
        EmailBroadcastList,
        EmailTemplates,
        SidebarChild,
        NewMailInterface,
    },
    props: {},
    data() {
        return {
            defaultPath: this.$route.path,
            queryAction: this.$route.query.action,
            selectedTab: this.$route.path.replace(/(\/mails\/|\/mails)/g, "") || "inbox",
            menuItems: [
                {
                    enabled: true,
                    key: "inbox",
                    label: this.$t("mail.inbox"),
                    icon: {
                        type: "material-icons",
                        name: "email",
                    },
                },
                {
                    enabled: true,
                    key: "templates",
                    label: this.$t("mail.templates"),
                    icon: {
                        type: "material-icons",
                        name: "drafts",
                    },
                },
                {
                    enabled: true,
                    key: "broadcast",
                    label: this.$t("mail.broadcast"),
                    icon: {
                        type: "material-icons",
                        name: "cell_tower",
                    },
                },
                {
                    enabled: true,
                    key: "customer-groups",
                    label: this.$t("wp.customerGroups"),
                    icon: {
                        type: "material-icons",
                        name: "groups",
                    },
                },
            ].filter((item) => item.enabled),
        };
    },
    computed: {
        ...mapState({
            userInteracted: (state) => state.app.userInteracted,
            emailNotification: (state) => state.mail.emailNotification,
            emailSendSuccess: (state) => state.mail.emailSendSuccess,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapMutations({
            CHANGE_SELECTED_MENU: "mail/CHANGE_SELECTED_MENU",
            CHANGE_SELECTED_DEPARTMENT: "mail/CHANGE_SELECTED_DEPARTMENT",
            SELECTED_MAIL: "mail/SELECTED_MAIL",
            playEmailNotification: "mail/playEmailNotification",
            SELECTED_NEW_MAIL: "mail/SELECTED_NEW_MAIL",
        }),
        playNotificationSound: _.debounce(function (isReceive = false) {
            newMailSound().play();
        }, 1000),
        IsEmailEnabled() {
            return CONFIG.EMAIL_SERVICE_ENABLED;
        },
        handleSidebarSelection(item) {
            this.selectedTab = item.key;
        },
        isSelected(type) {
            const items = this.menuItems;
            const item = items.find((item) => item?.parentKey === this.selectedTab || item.key === this.selectedTab);
            return item.key === type || item.parentKey === type;
        },
        setDefaultPath: _.debounce(function () {
            this.defaultPath = this.$route.path;
        }, 0),
        init() {
            this.selectedTab = this.defaultPath.replace(/(\/mails\/|\/mails)/g, "") || "inbox";
            const selected = this.menuItems.find((x) => x.key === this.selectedTab);
            if (!selected?.enabled) {
                const available = this.menuItems.find((x) => x.enabled);
                if (available) {
                    this.selectedTab = available.key;
                } else {
                    this.$router.push("/denied");
                }
            }
        },
        newMailReceived: _.debounce(function () {
            this.$message.success(this.$t("mail.newMailArrived"), 3);
            if (this.userInteracted) {
                this.playNotificationSound();
            }
            this.playEmailNotification(false);
        }, 1000),
        mailSuccessDelivered: _.debounce(function () {
            this.$message.success(this.$t("mail.mailSentSucs"), 3);
        }, 1000),
    },
    created() {
        this.init();
    },
    watch: {
        emailNotification(val) {
            if (val === true) this.newMailReceived();
        },
        emailSendSuccess(val) {
            if (val) this.mailSuccessDelivered();
        },
        selectedTab(newVal) {
            this.$router.push(`/mails/${newVal}`);
        },
        "$route.path": {
            deep: true,
            handler(val) {
                this.setDefaultPath(val);
            },
        },
        defaultPath(val) {
            this.init(val);
        },
    },
};
</script>

<style lang="scss">
#mailbox {
    background-color: #ffffff;
    width: 100%;

    .route-page-content {
        width: 100%;
    }

    .ant-spin-nested-loading {
        width: 100% !important;
        display: flex !important;
    }

    .ant-spin-container {
        width: 100% !important;
        display: flex !important;
    }

    #mailbox-in {
        display: flex;
        position: relative;
        width: 100%;

        .empty-mail {
            justify-content: center;
            width: 100%;
            display: flex;
            align-items: center;
        }

        .mail-composer {
            width: 100%;
            border-right: 1px solid var(--color-border-default);
        }
    }
}
</style>
